import React, { useState, useEffect } from 'react';

import { useLayoutContext } from '@contexts/LayoutContext';

import { NwButton } from '@components/Gui/NwButton';
import NwSelect from '@components/Gui/NwForm/CustomSelect';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';

const OptionSelectorAllDates = ({ onExtendOptionNumber }) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const { isMobile } = useLayoutContext();

    const handleSave = () => {
        onExtendOptionNumber(selectedValue);
    };

    const options = [
        { value: 10, label: 'JOB' },
        ...[...Array(5).keys()].map((key) => ({ value: key + 1, label: key + 1 })),
    ];

    return isMobile ? (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <NwSelect
                value={selectedValue}
                onChange={setSelectedValue}
                options={options}
                style={{ flex: 1 }}
                placeholder="Select option"
            />
            <NwButton onClick={handleSave} type="primary" label="Save" />
        </div>
    ) : (
        <RadioButtonGroup
            onChange={(value) => {
                onExtendOptionNumber(value);
            }}
            size="small"
            options={options}
        />
    );
};

export default OptionSelectorAllDates;
